var block_news = {
  ui: {},

  init: function () {
    this.bindUI()
    this.bindEvents()

    this.initSlider()
  },

  bindUI: function () {
    this.ui.$slider = $('.js-news-slider')
  },

  bindEvents: function () {
    // this.ui.$slick.on('ready', this.mediaToCarousel.bind(this));
  },

  initSlider: function () {
    this.ui.$slider.slick({
      slidesToShow: 2.5,
      slideToScroll: 2,
      dots: true,

      centerMode: false,
      arrows: false,
      infinite: false,

      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
          },
        }
      ],
    })
  },
}

module.exports = block_news
